import React from 'react';
import {ProtectedRoute} from '../../_common/components/Permissions';
import {InspectionsMapPage} from '../pages';
import {pathnames as P} from '../../_common/constants/pathnames';
import {subjects as S} from '../../_common/constants/permissionSubjects';

export const inspectionsMapPageRoute = (
  <ProtectedRoute
    subject={S.INSPECTIONS_MAP_PAGE}
    path={P.INSPECTIONS_MAP_PAGE}
    component={InspectionsMapPage}
  />
);
